var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.648,
    height: 22.292,
    viewBox: "0 0 18.648 22.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_17_",
    "data-name": "user (17)",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88562",
    "data-name": "Path 88562",
    d: "M92.329,10.594a5.125,5.125,0,0,0,3.745-1.552A5.126,5.126,0,0,0,97.626,5.3a5.126,5.126,0,0,0-1.552-3.745,5.3,5.3,0,0,0-7.49,0A5.125,5.125,0,0,0,87.032,5.3a5.125,5.125,0,0,0,1.552,3.745A5.127,5.127,0,0,0,92.329,10.594ZM89.495,2.463a4.007,4.007,0,0,1,5.668,0A3.829,3.829,0,0,1,96.337,5.3a3.829,3.829,0,0,1-1.174,2.834,4.006,4.006,0,0,1-5.668,0A3.828,3.828,0,0,1,88.32,5.3a3.829,3.829,0,0,1,1.174-2.834Zm0,0",
    transform: "translate(-83.293 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88563",
    "data-name": "Path 88563",
    d: "M18.3,253.6a13.082,13.082,0,0,0-.178-1.39,10.948,10.948,0,0,0-.342-1.4,6.9,6.9,0,0,0-.574-1.3,4.911,4.911,0,0,0-.866-1.129A3.819,3.819,0,0,0,15.1,247.6a4.3,4.3,0,0,0-1.588-.287,1.612,1.612,0,0,0-.861.365c-.258.168-.56.363-.9.578a5.137,5.137,0,0,1-1.16.511,4.506,4.506,0,0,1-2.839,0,5.122,5.122,0,0,1-1.16-.511c-.334-.213-.636-.408-.9-.579a1.61,1.61,0,0,0-.861-.365,4.3,4.3,0,0,0-1.588.288A3.816,3.816,0,0,0,2,248.386a4.913,4.913,0,0,0-.866,1.128,6.913,6.913,0,0,0-.574,1.3,10.973,10.973,0,0,0-.342,1.4,12.992,12.992,0,0,0-.178,1.39c-.029.42-.044.857-.044,1.3a3.652,3.652,0,0,0,1.085,2.763,3.9,3.9,0,0,0,2.795,1.019H14.468a3.9,3.9,0,0,0,2.795-1.019,3.65,3.65,0,0,0,1.085-2.763c0-.443-.015-.88-.044-1.3Zm-1.929,3.128a2.628,2.628,0,0,1-1.906.664H3.879a2.628,2.628,0,0,1-1.906-.664,2.385,2.385,0,0,1-.684-1.829c0-.412.014-.819.041-1.21a11.724,11.724,0,0,1,.161-1.252,9.682,9.682,0,0,1,.3-1.232,5.631,5.631,0,0,1,.467-1.06,3.643,3.643,0,0,1,.636-.834,2.533,2.533,0,0,1,.828-.515,2.966,2.966,0,0,1,1.015-.2c.045.024.126.07.256.155.265.173.57.37.908.585A6.385,6.385,0,0,0,7.357,250a5.792,5.792,0,0,0,3.631,0,6.4,6.4,0,0,0,1.457-.651c.345-.221.642-.412.907-.585.13-.085.211-.131.256-.155a2.968,2.968,0,0,1,1.015.2,2.537,2.537,0,0,1,.828.515,3.632,3.632,0,0,1,.636.834,5.61,5.61,0,0,1,.468,1.059,9.657,9.657,0,0,1,.3,1.232,11.818,11.818,0,0,1,.161,1.252h0c.027.389.041.8.041,1.209a2.385,2.385,0,0,1-.685,1.829Zm0,0",
    transform: "translate(0 -236.693)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser17);
export default __webpack_public_path__ + "static/media/user (17).40c51d9b1e34aebefd21facb11e821c9.svg";
export { ForwardRef as ReactComponent };